import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { ParkingFacilityDetailContent } from '@/components/map/details/content/ParkingFacilityDetailContent';
import { DetailPopup } from '@/components/map/details/popup/DetailPopup';
import {
  backendApiParkingDataFindAllLatestParkingFacilityDataOptions,
  backendApiParkingFacilitiesFindOneOptions,
} from '@/modules/api/backend/@tanstack/react-query.gen';
import { FeatureType } from '@/types/FeatureType';
import { MapLayer } from '@/types/MapLayer';

interface ParkAndRideFacilityPopupContentProps {
  id: string;
}

export function ParkingFacilityPopup({ id }: ParkAndRideFacilityPopupContentProps) {
  const { data: parkingFacility } = useSuspenseQuery(
    backendApiParkingFacilitiesFindOneOptions({
      path: { parkingFacilityId: id },
    }),
  );

  const { data: parkingFacilityData } = useQuery({
    ...backendApiParkingDataFindAllLatestParkingFacilityDataOptions(),
    select: (data) => data.find((item) => item.id === id),
  });

  if (!parkingFacility.geometry) {
    return null;
  }

  return (
    <DetailPopup
      id={id}
      mapLayer={MapLayer.PARKING_FACILITY}
      point={parkingFacility.geometry}
      title={parkingFacility.name}
      type={FeatureType.PARKING_FACILITY}
    >
      <ParkingFacilityDetailContent data={parkingFacilityData} facility={parkingFacility} />
    </DetailPopup>
  );
}
